module.exports = __webpack_public_path__ + "img/gntech_gallery10.042d01d8.jpg";